module.exports = "/_next/static/images/26b4635284fc149e2b5bdd7825ae1ded-slide-3-large.png.webp";